import chatgptLogo from '../../../assets/chatgpt-logo.svg';
import claudeLogo from '../../../assets/claude-logo.svg';

export const AGENTS = [
  {
    name: 'Claude',
    logo: claudeLogo,
    lines: ['Add the new stocks', 'listed today.'],
    x: 8,
    y: 58,
    color: 'prism.violet' as const,
  },
  {
    name: 'ChatGPT',
    logo: chatgptLogo,
    lines: ['Flag anything down', 'more than 20% this', 'week.'],
    x: 128,
    y: 8,
    color: 'prism.mid' as const,
  },
];
